import * as lexLangActionType from '../actionsType/miscellaneous.actionType';

export const initialState = {
    lexContentData: null
};

export function lexLangLaunchReducer(state = initialState, action) {
    switch (action.type) {
        case lexLangActionType.SET_LEX_LANG_LAUNCH:
            return {lexContentData: action.payload};
        default:
            return state;
    }
}
